import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const TurnsService = {
  async getTurns(page, perPage, filters, tribe_id) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get('org/v1/circulations/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createTurns(payload) {
    const res = await axios.post('org/v1/circulations/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteTurns(clientId) {
    const res = await axios.delete(`org/v1/circulations/${clientId}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateTurns(payload, clientId) {
    const res = await axios.put(`org/v1/circulations/${clientId}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async uploadTruns(clientId, payload) {
    const res = await axios.post(
      `org/v1/circulations/import/?client_id=${clientId}`,
      payload
    );

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },
};
